import formatCurrency, {
    CurrencyFormatKeys,
    AmountValue,
} from '@ilg-totallymoney/formatcurrency'

function formatNumberToCurrency(
    amountValue: AmountValue,
    currencyFormat?: CurrencyFormatKeys
) {
    return formatCurrency(amountValue, currencyFormat)
}

export default formatNumberToCurrency
